import { render, staticRenderFns } from "./ConfigurationModal.vue?vue&type=template&id=70a0416a&scoped=true&"
import script from "./ConfigurationModal.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a0416a",
  null
  
)

export default component.exports